module.exports = __webpack_public_path__ + "assets/message-white-c2900b2a69afe6108910fe301b05f39a.svg";